import { render, staticRenderFns } from "./platformWinLoseTab.vue?vue&type=template&id=0f4ed9ad&lang=pug"
import script from "./platformWinLoseTab.vue?vue&type=script&lang=js"
export * from "./platformWinLoseTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports